// removed by extract-text-webpack-plugin
module.exports = {"alignItemCenter":"alignItemCenter__3SIf-"};


//////////////////
// WEBPACK FOOTER
// ./components/homePageNew/topFundsSection/topFundsSection.scss
// module id = 504
// module chunks = 68